// Обобщението на „Дневник на резервациите" върху ПОКАЗАНИТЕ редове.
//
// BE връща `summary` за целия период, но кутийките следват търсачката и
// филтрите в колоните, както таблицата и Excel (същото решение като в
// „Монитори" и „По станции"). Формулите повтарят BE-то: гостите са само по
// резервациите, които не са отказани или неизпълнени; оборотът е сборът на
// сметките (без сметка идва null и не влиза), всяка
// сметка веднъж — по уникален `bill_id` (стари данни: две резервации на
// една сметка не удвояват оборота).

import { parseDecimal } from "../../../../components/dataTable";
import type { ReservationJournalRow } from "../../../../api/reportsReservations";
import type { ReservationStatusCounts } from "../../../../api/reportsReservations";
import { emptyStatusCounts } from "./reservationReportFormat";

export type JournalSummaryView = ReservationStatusCounts & {
  guests: number;
  revenue: number;
  /** Средна група — гости на резервация, само по носещите гости. */
  averageParty: number | null;
};

const GUEST_BEARING = new Set(["upcoming", "seated", "completed"]);

export const countStatuses = <T extends { status: ReservationJournalRow["status"] }>(
  rows: readonly T[],
): ReservationStatusCounts => {
  const counts = emptyStatusCounts();
  for (const row of rows) {
    counts.reservations += 1;
    counts[row.status] += 1;
  }
  return counts;
};

export const summarizeJournalRows = (
  rows: readonly ReservationJournalRow[],
): JournalSummaryView => {
  const counts = countStatuses(rows);
  let guests = 0;
  let bearing = 0;
  let revenue = 0;
  const countedBills = new Set<number>();
  for (const row of rows) {
    if (GUEST_BEARING.has(row.status)) {
      guests += row.guests;
      bearing += 1;
    }
    if (row.bill_id === null || row.bill_total === null || countedBills.has(row.bill_id)) continue;
    countedBills.add(row.bill_id);
    revenue += parseDecimal(row.bill_total);
  }
  return {
    ...counts,
    guests,
    revenue,
    averageParty: bearing > 0 ? guests / bearing : null,
  };
};
